import store from 'config/store'
import { omit } from 'ramda'
import { broadcast, listen } from 'utils/message'

const UseStateSnapShot = () => {
  listen({
    topic: 'CONDUCTOR:request-state-from-controller',
    handler: ({ data }) => {
      const state = store.getState()

      broadcast({
        topic: `${data.name}:state-snap-shot`,
        message: {
          state: {
            ...omit(['session'], state),
            session: omit(['sockets'], state.session)
          }
        }
      })
    }
  })
  return store
}

export default UseStateSnapShot
